import { validarRol  } from "../../plugins/acl";
import { dataInitialReCAPTCHA , dataInitialMicrosoftOnline } from "./state";

export function login(state, auth) {
    state.status = true
    state.user = auth

}

/**
 * Mutación para almacenar el rol del usuario.
 *
 * @export
 * @param {*} state contiene la información del usuario
 */
export function setRol(state) {
    state.usuarioAdmin              = validarRol('superadmin') || validarRol('admin');
    state.usuarioEmpresa            = validarRol('empresa');
    state.usuarioEmpresaHSE         = validarRol('empresa-hse');
    state.usuarioEmpresaContratista = validarRol('empresa-contratista');
}

export function loginFail(state, error) {
    state.user = false
    state.error = error
}
export function cambiaTicket(state) {
    state.ticket = !state.ticket;
    if (state.columnas == 8) {
        state.columnas = 12;
    } else {
        state.columnas = 8;
    }
}

export function setUrl(state, url) {
    state.cambio.url = url;
}

/**
 * Mutación resetear el estado de Google reCAPTCHA.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetReCAPTCHA(state) {
    state.reCAPTCHA = dataInitialReCAPTCHA();
}

/**
 * Mutación resetear el estado de Google reCAPTCHA.
 *
 * @param {*} state
 * @param {Boolean} nextState
 * @author Libardo Bolaño
 */
export function reloadRECAPTCHA(state,nextState = true) {
    state.reCAPTCHA.reload = nextState;
}

/**
 * Mutación manipular/alterar el estado de las validación de Google reCAPTCHA.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setReCAPTCHA(state, nextState) {
    state.reCAPTCHA = nextState;
}

/**
 * Mutación manipular/alterar el estado de carga.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setLoading(state, nextState) {
    state.loading = nextState;
}

/**
 * Mutación resetear el estado de Microsoft Online.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetMicrosoftOnline(state) {
    state.microsoftOnline = dataInitialMicrosoftOnline();
}

/**
 * Mutación manipular/alterar el estado de Microsoft Online.
 *
 * @param {Object} state
 * @param {Object} {loading, isValid}
 * @author Fernando Claros
 */
// Controlar estado del nit de la empresa
export function setMicrosoftOnlineNitCompany(state, {loading, isValid}) {
    state.microsoftOnline.loadingNitCompany = loading;
    state.microsoftOnline.isValidNitCompany = isValid;
}
// Controlar estado de oermisos de la empresa
export function setMicrosoftOnlinePermissions(state, {loading, isValid}) {
    state.microsoftOnline.loadingPermissions = loading;
    state.microsoftOnline.isValidPermissions = isValid;
}
// Controlar acceso a Microsoft
export function setMicrosoftOnlineAccessToMicrosoft(state, {loading, isValid}) {
    state.microsoftOnline.loadingAccessToMicrosoft = loading;
    state.microsoftOnline.isValidAccessToMicrosoft = isValid;
}
// Controlar errores de la empresa
export function setMicrosoftOnlineHasErrorInSessionUser(state, nextState) {
    state.microsoftOnline.hasErrorInSessionUser = nextState
}
// Controlar configuraciones de azure para acceso a Soluquim
export function setMicrosoftOnlineIsValidConfigsAzure(state, {loading, isValid}) {
    state.microsoftOnline.isValidConfigsAzure = loading
    state.microsoftOnline.loadingConfigsAzure = isValid
}
// Controlar loading de configuraciones de azure
export function setMicrosoftOnlineLoadingConfigsAzure(state, nextState) {
    state.microsoftOnline.loadingConfigsAzure = nextState
}
// Controlar acceso a Soluquim
export function setMicrosoftOnlineLoadingAccessMicrosoftToApp(state, nextState) {
    state.microsoftOnline.loadingAccessMicrosoftToApp = nextState
}
// Controlar errores en el acceso
export function setMicrosoftOnlineMessageError(state, nextState) {
    state.microsoftOnline.messageError = nextState
}

/**
 * Mutación setear tiempo de conexion
 *
 * @param {*} state
 * @param {*} nextState
 * @author Paul Valencia
 */
export function setUserTime(state, users_time) {
    state.users_time = users_time;
}



/**
 * Mutación para setear el email del usuario lógueado.
 *
 * @param {*} state
 * @param {*} email
 * @author Paul Valencia
 */
export function setEmailUserLogged(state, email) {
    state.email = email;
}

/**
 * Mutación para sumar los intentos de reaundar session
 *
 * @param {*} state
 * @param {*} attempts
 * @author Paul Valencia
 */
export function setAttempt(state, attempts) {
    state.attempts += attempts;
}


/**
 * Reestablecer intentos
 *
 * @param {*} state
 * @param {*} attempts
 * @author Paul Valencia
 */
export function resetAttempts(state) {
    state.attempts = 0;
}


/**
 * Mutación para setear el originalRequest.
 *
 * @param {*} state
 * @param {*} originalRequest
 * @author Paul Valencia
 */
export function setOriginalRequest(state, originalRequest) {
    state.originalRequest = originalRequest
}

/**
 * Reestablecer originalRequest
 *
 * @param {*} state
 * @author Paul Valencia
 */
export function clearOriginalRequest(state) {
    state.originalRequest = null;
}


/**
 * Cambiar estado de que se cerro la sesión
 *
 * @param {*} state
 * @author Paul Valencia
 */
export function changeCloseSession(state, data) {
    state.closeSession = data;
}

/**
 * Estado actual del request.
 *
 * @param {*} state
 * @author Paul Valencia
 */
export function setStatusResponse(state, statusResponse) {
    state.statusResponse = statusResponse;
}

/**
 * Cambia la informacion basica del usuario.
 *
 * @param {*} state
 * @param {*} basicInfoUser
 */
export function setBasicicInfoUser(state, basicInfoUser) {
    state.basicInfoUser = basicInfoUser;
}

/**
 * Mutación que establece actualiza la notificacion sobre la licencia de la empresa.
 *
 * @param {*} state
 * @param {*} licence_warning
 */
export function setLicenseWarning(state, licence_warning) {
    state.licence_warning = licence_warning;
}
